import React, { useState } from 'react';

import { Text, ToggleGroup } from '@betterment/samba-react';
import { Card } from '@betterment/style-closet-react';

import AllTimeContributions from './components/allTimeContributions';
import CurrentYearContributions from './components/currentYearContributions';
import ShimmerLoader from './components/shimmerLoader';
import { useFourOhOneKContributionsCurrentYearQuery } from './hooks';

const FourOhOneKContributions: React.FC<React.PropsWithChildren> = () => {
  const [timePeriodSelection, setTimePeriodSelection] = useState('currentYear');
  const { isLoading, fourOhOneKContributionCurrentYear, employers } = useFourOhOneKContributionsCurrentYearQuery();

  return (
    <>
      {isLoading && <ShimmerLoader />}
      {!isLoading && fourOhOneKContributionCurrentYear && (
        <Card isRounded={true}>
          <Card.Slot name="header">
            <Text>Your 401(k) contributions</Text>
          </Card.Slot>
          <Card.Slot name="body">
            <ToggleGroup
              onValueChange={(value: string) => {
                if (value !== '') {
                  setTimePeriodSelection(value);
                }
              }}
              spacing="default"
              type="single"
              value={timePeriodSelection}
            >
              <ToggleGroup.Item value="currentYear">
                <Text>This Year</Text>
              </ToggleGroup.Item>
              <ToggleGroup.Item value="allTime">
                <Text>All Time</Text>
              </ToggleGroup.Item>
            </ToggleGroup>
            {timePeriodSelection === 'currentYear' && (
              <CurrentYearContributions
                fourOhOneKContributionCurrentYear={fourOhOneKContributionCurrentYear}
                employers={employers || []}
              />
            )}
            {timePeriodSelection === 'allTime' && <AllTimeContributions />}
          </Card.Slot>
        </Card>
      )}
    </>
  );
};

export default FourOhOneKContributions;
